import React, { useState } from "react";
import { Form, Input, Space, Tooltip as AntTooltip, Spin, Card, Col, Row, Table, Button, Tabs, Modal, message } from "antd";
import { useReportsStore } from "../../store/slices/createReportsSlice";
import moment from "moment-jalaali";
import strings from "../../utils/strings";
import { ZoomInOutlined } from "@ant-design/icons";
import PerformanceReportTab from "./PerformanceReportTab";
import CrmTicketReport from "../user-business-report/crmReport/crmTicket/CrmTicketReport";
import CrmLoginReport from "../user-business-report/crmReport/CrmLoginReport";
import CrmSmsReport from "../user-business-report/crmReport/CrmSmsReport";
import CrmWallet from "../user-business-report/crmReport/crmCallHistory/CrmWallet";
import CrmCallHistory from "../user-business-report/crmReport/crmCallHistory/CrmCallHistory";
import CrmUserReceipt from "../user-business-report/crmReport/CrmUserReceipt";
import ReferralReport from "../users/ReferralReport";
import CrmRequestReport from "../user-business-report/crmReport/crmRequest/CrmRequestReport";
import UserInformationTab from "../shared/userInformation/UserInformationTab";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

const { TabPane } = Tabs;

export default function PromoterUsersReport() {
    const reports = useReportsStore();
    const general = useGeneralStore();
    const [form] = Form.useForm();
    const [searchValue, setSearchValue] = useState("");
    const promoterUsersReportData = reports.promoterUsersReport.data;
    const loading = reports.promoterUsersReport.loading;

    const [selectedUser, setSelectedUser] = useState(null);

    const visible = general.view.promoterUserModal;
    const [tabId, setTabId] = useState("1");
    const [category, setCategory] = useState(1);
    const [usrUserID, setUsrUserID] = useState();

    const pageSize = 10;
    // Function to clear modal data
    const clearModalData = () => {
        setTabId("1");
        general.TogglePromoterUserModal(false);
        setSelectedUser(null);
        setUsrUserID(undefined);
        // Clear the store data
        reports.clearMarketerDashboardReport();
        reports.clearUserInfo();
    };

    function tabIdSetter(key) {

        setTabId(key);

        switch (key) {
            case "1":
                setCategory(0)
                break;
            case "2":
                setCategory(1)
                reports.getCrmRequestReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                    CategoryPaymentStatus: 1,
                })

                break;
            case "3":
                setCategory("Ticket")
                reports.getCrmTicketReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                })
                break;
            case "4":
                setCategory("Sms")
                reports.getCrmSmsReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                })

                break;
            case "5":
                setCategory("Login")
                reports.getCrmLoginReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                })
                break;
            case "6":
                reports.getCrmWallet(usrUserID);
                setCategory("")
                break;
            case "7":
                if (usrUserID) {
                    reports.getCrmCallHistory(usrUserID)
                } else message.error("آی دی کاربر یافت نشد")
                setCategory("")
                break;
            case "8":
                reports.getUserReceipt(usrUserID);
                setCategory("")
                break;
            case "9":
                reports.getReferralReport({ param: usrUserID });
                setCategory("")
                break;
            default:
                break;
        }
    }
    const columns = [
        {
            title: "جزئیات",
            dataIndex: "operation",
            key: "operation",
            width: 100,
            render: (_, record) => {
                return (<Space size="middle">
                    <Button
                        type="link"
                        onClick={() => {
                            setSelectedUser(record);
                            general.TogglePromoterUserModal(true);
                            setUsrUserID(record.UsrUserID);

                        }}
                        size="small"
                    >
                        <ZoomInOutlined />
                    </Button>
                </Space>)
            }
        },
        { title: "نام", dataIndex: "FirstName", key: "FirstName" },
        { title: "نام خانوادگی", dataIndex: "LastName", key: "LastName" },
        { title: "نام و نام‌خانوادگی", dataIndex: "FullName", key: "FullName" },
        { title: "شماره موبایل", dataIndex: "MobileNumber", key: "MobileNumber" },
        { title: "نام کاربری", dataIndex: "UserName", key: "UserName" },
        { title: "نام بیزینس", dataIndex: "BusinessName", key: "BusinessName" },
        { title: "نام پدر", dataIndex: "FatherName", key: "FatherName" },
        {
            title: "ایمیل",
            dataIndex: "Email",
            key: "Email",
            width: 140,
            render: (text) => (
                <AntTooltip title={text} placement="topLeft">
                    <div style={{
                        maxWidth: '140px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                        {text}
                    </div>
                </AntTooltip>
            )
        },

        { title: "شماره شبا", dataIndex: "IBAN", key: "IBAN" },
        { title: "بانک", dataIndex: "Bank", key: "Bank" },
        { title: "شماره کارت", dataIndex: "BankCardNumber", key: "BankCardNumber" },
        { title: "شماره حساب", dataIndex: "BankAccountNumber", key: "BankAccountNumber" },
        {
            title: "تاریخ آخرین لاگین",
            dataIndex: "LastUsed",
            key: "LastUsed",
            render: data => data ? strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm')) : ""
        }
    ];



    function onFinish() {
        if (searchValue) {
            reports.getPromoterUsersReport(searchValue);
        }
    }



    return (
        <Row>
            <Col span={24}>
                <Card>
                    <Form
                        className="align-items-end"
                        layout="inline" form={form} onFinish={onFinish}>
                        <Form.Item>
                            <label htmlFor="search">نام یا شماره موبایل</label>
                            <Input
                                value={searchValue}
                                onChange={e => setSearchValue(e.target.value)}
                                placeholder="نام یا شماره موبایل"
                                name="search"
                                className="form-input"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                style={{ paddingInline: '24px' }}
                                className="primary-button waves-effect waves-light"
                                type="primary" htmlType="submit" loading={loading}>
                                جستجو
                            </Button>
                        </Form.Item>
                    </Form>
                    <Spin spinning={loading}>
                        <Table
                            loading={loading}
                            style={{ marginTop: 16 }}
                            dataSource={promoterUsersReportData?.length > 0 ? promoterUsersReportData : []}
                            columns={columns}
                            rowKey="UsrUserID"
                            bordered
                            size="small"
                            scroll={{ x: 'max-content' }}
                        />

                    </Spin>
                </Card>
            </Col>

            <Modal
                style={{ top: 20 }}
                title={`جزییات بازاریاب - ${selectedUser?.FullName || ''}`}
                className="custom-table crm-modal"
                visible={visible}
                footer={null}
                width="90%"
                onCancel={clearModalData}
            >
                <div className='showBusiness-tab crm-request'>
                    <Tabs
                        defaultActiveKey="1"
                        activeKey={tabId.toString()}
                        onChange={tabIdSetter}
                        type='card'
                        tabPosition="right"
                    >
                        <TabPane tab="گزارش عملکرد" key="1">
                            <PerformanceReportTab
                                selectedUser={selectedUser}
                                visible={visible}
                                tabId={tabId}
                            />
                        </TabPane>
                        <TabPane tab="درخواست ها" key="2">
                            <CrmRequestReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                        </TabPane>
                        <TabPane tab="اطلاعات کاربر" key="info">
                            <UserInformationTab
                                userId={usrUserID}
                                active={tabId.toString() === "info"}
                            />
                        </TabPane>
                        <TabPane tab="تیکت ها" key="3">
                            <CrmTicketReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                        </TabPane>
                        <TabPane tab="پیامک های ارسالی" key="4">
                            <CrmSmsReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                        </TabPane>
                        <TabPane tab="ورود به سیستم" key="5">
                            <CrmLoginReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                        </TabPane>
                        <TabPane tab="كيف پول" key="6">
                            <CrmWallet />
                        </TabPane>
                        <TabPane tab="گزارش تماس" key="7">
                            <CrmCallHistory usrUserID={usrUserID} />
                        </TabPane>
                        <TabPane tab="رسیدهای کاربر" key="8">
                            <CrmUserReceipt usrUserID={usrUserID} />
                        </TabPane>
                        <TabPane tab="گزارش دعوت از دوستان" key="9">
                            <ReferralReport usrUserID={usrUserID} />
                        </TabPane>
                    </Tabs>
                </div>
            </Modal>
        </Row>
    );
}
